import { render, staticRenderFns } from "./qs1-07.vue?vue&type=template&id=f2ea5e30&scoped=true&"
import script from "./qs1-07.vue?vue&type=script&lang=js&"
export * from "./qs1-07.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ea5e30",
  null
  
)

export default component.exports